module.exports = "decline-cross"